import React, { useContext, useState, useMemo, useRef, useCallback } from "react";
import Cookies from "js-cookie";


const AppContext = React.createContext();
const GlobalProvider = ({ children }) => {

  // TODO REMOVE AFTER DEBUGGING (including useRef, useCallback from import)
  // This is a helper method to trace when a state changes.
  // usage:
  // replace  [...] = useState(null);   with:
  // [...] = useTrackedState(null, 'name of the state');
  // eslint-disable-next-line no-unused-vars
  const useTrackedState = (initialValue, name) => {
    const [state, setState] = useState(initialValue);
    const stateRef = useRef(state); // ← track current value without deps
  
    const trackedSetState = useCallback((newValue) => {
      console.group(`[STATE CHANGE] ${name}`);
      console.log('Previous:', stateRef.current);
      console.log('Next:', typeof newValue === 'function' ? '(function)' : newValue);
      console.trace();
      console.groupEnd();
  
      setState((prev) => {
        stateRef.current = typeof newValue === 'function' ? newValue(prev) : newValue;
        return stateRef.current;
      });
    }, [name]); // ← name is stable, no state in deps
  
    return [state, trackedSetState];
  }

  const [uploadImage, setUploadImage] = useState(null);
  const [modalVertices, setModalVertices] = useState([]);
  const [initialVertices, setInitialVertices] = useState([]);
  const [modalData, setModalData] = useState([]);
  const [boxes, setBoxes] = useState([]);
  // OCR plan-label covers only. Must stay separate from `boxes`, which the
  // editor scale/measurement path still reads — populating that with CV
  // text_boxes would change scale-wall picking once OCR returns data.
  const [planLabelBoxes, setPlanLabelBoxes] = useState([]);
  const [resData, setResData] = useState(null);
  const [revertResData, setRevertResData] = useState(null);
  const [selectZones, setSelectZones] = useState([]);

  const [stackedLayouts, setStackedLayouts] = useState([]);

  const [floors, setFloors] = useState();

  const [activeStep, setActiveStep] = useState(0);

  const [style, setStyle] = useState("");


  const [editVersionLayout, setEditVersionLayout] = useState(null);
  const [activeLayout, setActiveLayout] = useState(null);
  const [showVersionLayout, setShowVersionLayout] = useState(null);
  const [forkTransitioning, setForkTransitioning] = useState(false);
  const [doneEditing, setDoneEditing] = useState(false);

  const [activePartner, setActivePartner] = useState(Cookies.get("activePartner"))

  const [value, setValue] = useState("1");
  const [clientRef, setClientRef] = useState(null);


  const handleBack = () => {
    setActiveStep((prevActiveStep) => prevActiveStep - 1);
  };

  const contextValue = useMemo(() => ({
    handleBack,
    activeStep,
    setActiveStep,
    selectZones,
    setSelectZones,
    style,
    setStyle,
    resData,
    setResData,
    revertResData,
    setRevertResData,
    setUploadImage,
    uploadImage,
    setModalVertices,
    setInitialVertices,
    initialVertices,
    modalVertices,
    setModalData,
    modalData,
    setBoxes,
    boxes,
    setPlanLabelBoxes,
    planLabelBoxes,
    floors,
    setFloors,
    stackedLayouts,
    setStackedLayouts,
    activeLayout,
    setActiveLayout,
    editVersionLayout,
    setEditVersionLayout,
    showVersionLayout,
    setShowVersionLayout,
    forkTransitioning,
    setForkTransitioning,
    doneEditing,
    setDoneEditing,
    value,
    setValue,
    setActivePartner,
    activePartner,
    setClientRef,
    clientRef
  }), [
    activeStep,
    selectZones,
    style,
    resData,
    revertResData,
    uploadImage,
    initialVertices,
    modalVertices,
    modalData,
    boxes,
    planLabelBoxes,
    floors,
    stackedLayouts,
    activeLayout,
    editVersionLayout,
    showVersionLayout,
    forkTransitioning,
    doneEditing,
    value,
    activePartner,
    clientRef,
  ]);

  return (
    <AppContext.Provider value={contextValue}>
      {children}
    </AppContext.Provider>
  );
};

export const useGlobalContext = () => {
  return useContext(AppContext);
};

export { AppContext, GlobalProvider };
